import { AppName } from '../../../types/app'
import { EncounterStatus } from '../types/base'
import { EncounterType } from '../types/encounterType'

export const encounterTypeName: Record<EncounterType, string> = {
  [EncounterType.PHYSICAL]: 'Physical Exam',
  [EncounterType.ENCOUNTER]: 'Encounter',
  [EncounterType.WELL_WOMAN]: 'Well Woman Encounter',
  [EncounterType.PRE_CONCEPTION]: 'Pre-Conception Consultation',
  [EncounterType.ANTEPARTUM]: 'Antepartum Encounter',
  [EncounterType.POSTPARTUM]: 'Postpartum Encounter',
  [EncounterType.BIRTHING_CENTER_ADMISSION]: 'Birthing Center Admission',
  [EncounterType.ULTRASOUND]: 'Ultrasound',
}

export const pregnancyEncounterTypes: EncounterType[] = [
  EncounterType.ANTEPARTUM,
  EncounterType.POSTPARTUM,
  EncounterType.BIRTHING_CENTER_ADMISSION,
  EncounterType.ULTRASOUND,
]

export const patientEncounterTypes: EncounterType[] = [
  EncounterType.PHYSICAL,
  EncounterType.ENCOUNTER,
  EncounterType.WELL_WOMAN,
  EncounterType.PRE_CONCEPTION,
]

export const encounterStatusLabels: Record<EncounterStatus, string> = {
  [EncounterStatus.DRAFT]: 'Draft',
  [EncounterStatus.COMPLETED]: 'Completed',
  [EncounterStatus.AUTHENTICATED]: 'Authenticated',
}

// §1.6 / §6.4.1 — app-split status vocabulary. The billing-facing admin app ('app') labels the
// COMPLETED (Saved / Draft Complete) status "Saved — Ready for Auth" to match the billing
// dashboard's "Draft Complete — Ready for Auth" flag. The provider app keeps "Completed" for now
// (provider-facing rename is pending HB/Katie confirmation). DRAFT and AUTHENTICATED already match
// spec vocabulary in both apps.
export const getEncounterStatusLabel = (status: EncounterStatus, appName: AppName): string => {
  if (status === EncounterStatus.COMPLETED && appName === 'app') return 'Saved — Ready for Auth'
  return encounterStatusLabels[status]
}
